import { gql } from '@apollo/client'
import { CountryTagDataReference } from '@fs/zion-rootstech'

export default function getBsCountries() {
  return gql(`
    ${CountryTagDataReference}
    query QueryCountries {
      ConferenceDataViewModel {
        countryTags {
          ...CountryTagDataReference
        }
      }
    }
  `)
}
